import React, { Component } from 'react';
import Swiper from 'swiper';

class ServicesHome extends Component {
    componentDidMount() {
        new Swiper( '.adv-slider-services .adv-swiper-container', {
            // ADV swiper
            noSwipingClass: 'adv-swiper-no-swiping',
            containerModifierClass: 'adv-swiper-container-',
            slideClass: 'adv-swiper-slide',
            slideBlankClass: 'adv-swiper-slide-invisible-blank',
            slideActiveClass: 'adv-swiper-slide-active',
            slideDuplicateActiveClass: 'adv-swiper-slide-duplicate-active',
            slideVisibleClass: 'adv-swiper-slide-visible',
            slideDuplicateClass: 'adv-swiper-slide-duplicate',
            slideNextClass: 'adv-swiper-slide-next',
            slideDuplicateNextClass: 'adv-swiper-slide-duplicate-next',
            slidePrevClass: 'adv-swiper-slide-prev',
            slideDuplicatePrevClass: 'adv-swiper-slide-duplicate-prev',
            wrapperClass: 'adv-swiper-wrapper',
            navigation: {
                disabledClass: 'adv-swiper-button-disabled',
                hiddenClass: 'adv-swiper-button-hidden',
                lockClass: 'adv-swiper-button-lock',
                nextEl: '.adv-2-swiper-button-next',
                prevEl: '.adv-2-swiper-button-prev'
            },
            spaceBetween: 0,
            slidesPerView: 'auto'
        } );
    }

    render() {
        return (
            <section id="services" className="block">
                <div className="adv-slider-services">
                    <div className="adv-swiper-container">
                        <div className="adv-swiper-wrapper services-items clearfix">
                            <a title="Herrklippning" className="adv-swiper-slide services-item" href={ process.env.PUBLIC_URL + "/services-inside" }>
                                <div className="services-item-content">
                                    <h3 className="services-item-t-head">Herrklippning</h3>

                                    <span className="btn btn-lg btn-before-dot btn-link border-0 p-0 min-w-auto link-no-space">Priser</span>
                                </div>

                                <div className="img object-fit">
                                    <div className="object-fit-cover">
                                        <img
                                            src="https://i.ibb.co/n1Q6RDd/herklipp.jpg"
                                            src="https://i.ibb.co/0jwN04G/herklipp.jpg"
                                            alt="Haircut"
                                        />
                                    </div>
                                </div>

                                <div className="img-bg-color"></div>
                            </a>

                            <a title="Damklippning" className="adv-swiper-slide services-item" href={ process.env.PUBLIC_URL + "/services-inside" }>
                                <div className="services-item-content">
                                    <h3 className="services-item-t-head">Damklippning</h3>

                                    <span className="btn btn-lg btn-before-dot btn-link border-0 p-0 min-w-auto link-no-space">Priser</span>
                                </div>

                                <div className="img object-fit">
                                    <div className="object-fit-cover">
                                        <img
                                            src="https://i.ibb.co/g9bf8XC/damklipp.jpg"
                                            alt="Damklipp"
                                        />
                                    </div>
                                </div>

                                <div className="img-bg-color"></div>
                            </a>

                            <a title="Rakning" className="adv-swiper-slide services-item" href={ process.env.PUBLIC_URL + "/services-inside" }>
                                <div className="services-item-content">
                                    <h3 className="services-item-t-head">Rakning</h3>

                                    <span className="btn btn-lg btn-before-dot btn-link border-0 p-0 min-w-auto link-no-space">Priser</span>
                                </div>

                                <div className="img object-fit">
                                    <div className="object-fit-cover">
                                        <img
                                            src="https://i.ibb.co/3pWhk3z/rakning.jpg"
                                            alt="Rakning"
                                        />
                                    </div>
                                </div>

                                <div className="img-bg-color"></div>
                            </a>

                            <a title="Klippning & Rakning" className="adv-swiper-slide services-item" href={ process.env.PUBLIC_URL + "/services-inside" }>
                                <div className="services-item-content">
                                    <h3 className="services-item-t-head">Klippning & Rakning</h3>

                                    <span className="btn btn-lg btn-before-dot btn-link border-0 p-0 min-w-auto link-no-space">Priser</span>
                                </div>

                                <div className="img object-fit">
                                    <div className="object-fit-cover">
                                        <img src="https://i.ibb.co/NT3RPRS/klipprak.jpg"
                                             alt="Klippning & Rakning"
                                        />
                                    </div>
                                </div>

                                <div className="img-bg-color"></div>
                            </a>

                            <a title="Skäggtrimning" className="adv-swiper-slide services-item" href={ process.env.PUBLIC_URL + "/services-inside" }>
                                <div className="services-item-content">
                                        <h3 className="services-item-t-head">Skäggtrimning</h3>

                                    <span className="btn btn-lg btn-before-dot btn-link border-0 p-0 min-w-auto link-no-space">Priser</span>
                                </div>

                                <div className="img object-fit">
                                    <div className="object-fit-cover">
                                        <img
                                            src="https://i.ibb.co/rxtPsYf/beardtrim-min.jpg"
                                            loading="lazy"
                                            alt="Skäggtrimning" />
                                    </div>
                                </div>

                                <div className="img-bg-color"></div>
                            </a>

                            <a title="Ansiktsbehandling" className="adv-swiper-slide services-item" href={ process.env.PUBLIC_URL + "/services-inside" }>
                                <div className="services-item-content">
                                    <h3 className="services-item-t-head">Ansiktsbehandling</h3>

                                    <span className="btn btn-lg btn-before-dot btn-link border-0 p-0 min-w-auto link-no-space">Priser</span>
                                </div>

                                <div className="img object-fit">
                                    <div className="object-fit-cover">
                                        <img src="https://i.ibb.co/1qxDZ1Z/ansiktsbehandling.jpg" loading="lazy" alt="Ansiktsbehandling" />
                                    </div>
                                </div>

                                <div className="img-bg-color"></div>
                            </a>
                        </div>

                        <div className="adv-2-swiper-button-prev">
                            <span>
                                <span className="btn btn-lg btn-before-dot btn-link border-0 p-0 min-w-auto">Föregående</span>
                            </span>
                        </div>

                        <div className="adv-2-swiper-button-next">
                            <span>
                                <span className="btn btn-lg btn-after-dot btn-link border-0 p-0 min-w-auto">Nästa</span>
                            </span>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default ServicesHome;
